export default __webpack_public_path__ + "static/media/unlock.aacb5f37.mp3";